import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../use-api";

interface BackupArgusDriveInput {
  instanceId: string;
}

export function useBackupArgusDrive() {
  const queryClient = useQueryClient();
  const { callApi } = useApi<void>();

  return useMutation({
    mutationFn: async (input: BackupArgusDriveInput) => {
      await callApi(`/client/argus/instances/${input.instanceId}/backup`, {
        method: "POST",
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`/client/argus/instances/${variables.instanceId}`],
      });
    },
  });
}
